import * as yup from "yup";
import { numeric_integer_regix } from "../utils/functions";

export const investment_portfolio_schema = (data) => ({
    corpClientApplicationInvestmentPortfolioId: data?.corpClientApplicationInvestmentPortfolioId ?? null,
    whatIsTheValueOfTheInstitutionsExistingPortfolio: data?.whatIsTheValueOfTheInstitutionsExistingPortfolio ?? null,
    howLongHasTheInstitutionHeldTheseInvestments: data?.howLongHasTheInstitutionHeldTheseInvestments ?? null,
    existingPublicEquity: data?.existingPublicEquity ?? null,
    existingPrivateEquity: data?.existingPrivateEquity ?? null,
    existingRealEstate: data?.existingRealEstate ?? null,
    existingPrivateCredit: data?.existingPrivateCredit ?? null,
    existingFixedIncomeSukuk: data?.existingFixedIncomeSukuk ?? null,
    existingMoneyMarketMurabaha: data?.existingMoneyMarketMurabaha ?? null,
    existingTotal: data?.existingTotal ?? null,
    hasInstitutionInvestedInFinancialSecuritiesOutsideKSA: data?.hasInstitutionInvestedInFinancialSecuritiesOutsideKSA ?? null,
    estimateTotalSizeOfInstitutionInvestmentsInFinancialSecuritieOutsideKSA: data?.estimateTotalSizeOfInstitutionInvestmentsInFinancialSecuritieOutsideKSA ?? null,
    whatIsTheInstitutionsDebtToInvestmentRatio: data?.whatIsTheInstitutionsDebtToInvestmentRatio ?? null,
    whatIsTheInstitutionsGeneralInvestmentObjective: data?.whatIsTheInstitutionsGeneralInvestmentObjective ?? null,
    whatIsInstitutionsExpectedTimeHorizonForRedeemingTheseInvestments: data?.whatIsInstitutionsExpectedTimeHorizonForRedeemingTheseInvestments ?? null,
    whaIsTheInstitutionsRiskAppetite: data?.whaIsTheInstitutionsRiskAppetite ?? null,
    targetPublicEquity: data?.targetPublicEquity ?? null,
    targetPrivateEquity: data?.targetPrivateEquity ?? null,
    targetRealEstate: data?.targetRealEstate ?? null,
    targetPrivateCredit: data?.targetPrivateCredit ?? null,
    targetFixedIncomeSukuk: data?.targetFixedIncomeSukuk ?? null,
    targetMoneyMarketMurabaha: data?.targetMoneyMarketMurabaha ?? null,
    targetTotal: data?.targetTotal ?? null,
    isThereAnyOtherFinancialInformationThatYouWouldLikeToDiscloseOnBehalfOfTheInstitution: data?.isThereAnyOtherFinancialInformationThatYouWouldLikeToDiscloseOnBehalfOfTheInstitution ?? "",
    relationshipManagerName: data?.relationshipManagerName ?? "",
    doYouHaveAnExistingPortfolio: data?.doYouHaveAnExistingPortfolio ?? null,
    investmentPortfolioAccountActivities: data?.investmentPortfolioAccountActivities ?? [],
    investmentPortfolioCountries: data?.investmentPortfolioCountries ?? [],
    investmentPortfolioAccountActivities: data?.investmentPortfolioAccountActivities ?? [],
    investmentPortfolioPreferredCurrencies: data?.investmentPortfolioPreferredCurrencies ?? [],
    investmentPortfolioForeignCurrencies: data?.investmentPortfolioForeignCurrencies ?? [],
});

export const investment_portfolio_validation_schema = yup.object().shape({
    doYouHaveAnExistingPortfolio: yup
        .boolean()
        .nullable(),
        // .required("atleast_1_option_should_be_selected"),
    whatIsTheValueOfTheInstitutionsExistingPortfolio: yup
        .number()
        .nullable(),
        // .when("doYouHaveAnExistingPortfolio", {
        //     is: true,
        //     then: (schema) => schema.required("this_field_is_required"),
        //     otherwise: (schema) => schema.nullable(),
        // }),
    howLongHasTheInstitutionHeldTheseInvestments: yup
        .number()
        .nullable(),
        // .when("doYouHaveAnExistingPortfolio", {
        //     is: true,
        //     then: (schema) => schema.required("please_select"),
        //     otherwise: (schema) => schema.nullable(),
        // }),
    existingPublicEquity: yup.number().nullable(),
    existingPrivateEquity: yup.number().nullable(),
    existingRealEstate: yup.number().nullable(),
    existingPrivateCredit: yup.number().nullable(),
    existingFixedIncomeSukuk: yup.number().nullable(),
    existingMoneyMarketMurabaha: yup.number().nullable(),
    hasInstitutionInvestedInFinancialSecuritiesOutsideKSA: yup
        .boolean()
        .nullable(),
        // .when("doYouHaveAnExistingPortfolio", {
        //     is: true,
        //     then: (schema) => schema.required("atleast_1_option_should_be_selected"),
        //     otherwise: (schema) => schema.nullable(),
        // }),
    estimateTotalSizeOfInstitutionInvestmentsInFinancialSecuritieOutsideKSA: yup
        .string()
        .matches(numeric_integer_regix, "enter_a_valid_amount")
        .nullable(),
        // .when("doYouHaveAnExistingPortfolio", {
        //     is: true,
        //     then: (schema) => schema.when("hasInstitutionInvestedInFinancialSecuritiesOutsideKSA", {
        //         is: true,
        //         then: (schema) => schema.required("this_field_is_required"),
        //         otherwise: (schema) => schema.nullable(),
        //     }),
        //     otherwise: (schema) => schema.nullable(),
        // }),
    investmentPortfolioCountries: yup
        .array()
        .nullable(),
        // .when("doYouHaveAnExistingPortfolio", {
        //     is: true,
        //     then: (schema) => schema.when("hasInstitutionInvestedInFinancialSecuritiesOutsideKSA", {
        //         is: true,
        //         then: (schema) => schema.required("atleast_1_option_should_be_selected"),
        //         otherwise: (schema) => schema.nullable(),
        //     }),
        //     otherwise: (schema) => schema.nullable(),
        // }),
    whatIsTheInstitutionsDebtToInvestmentRatio: yup
        .number()
        .nullable(),
        // .when("doYouHaveAnExistingPortfolio", {
        //     is: true,
        //     then: (schema) => schema.moreThan(0, "atleast_1_option_should_be_selected"),
        //     otherwise: (schema) => schema.nullable(),
        // }),
    investmentPortfolioAccountActivities: yup
        .array()
        .nullable(),
        // .required("atleast_1_option_should_be_selected"),
    whatIsTheInstitutionsGeneralInvestmentObjective: yup
        .number()
        .nullable(),
        // .moreThan(0, "atleast_1_option_should_be_selected"),
    investmentPortfolioPreferredCurrencies: yup
        .array()
        .nullable(),
        // .of(
        //     yup.object().shape({
        //         portfolioPreferredCurrencyId: yup.number(),
        //         valueId: yup.number(),
        //     }),
        // )
        // .min(1, "atleast_1_option_should_be_selected"),
    whatIsInstitutionsExpectedTimeHorizonForRedeemingTheseInvestments: yup
        .number()
        .nullable(),
        // .required("this_field_is_required"),
    investmentPortfolioForeignCurrencies: yup
        .array()
        .nullable(),
})
// .test(
//     "foreign-currencies-required",
//     "this_field_is_required",
//     function (values) {
//         const { createError } = this;

//         const hasValueId790 = values?.investmentPortfolioPreferredCurrencies?.some(
//             (item) => item?.valueId === 790
//         );

//         // if (hasValueId790) {
//         //     if (!values?.investmentPortfolioForeignCurrencies || values.investmentPortfolioForeignCurrencies?.length === 0) {
//         //         return createError({
//         //             path: "investmentPortfolioForeignCurrencies",
//         //             message: "this_field_is_required",
//         //         });
//         //     }
//         // }

//         return true;
//     }
// )
.test(
    "existing-portfolio-breakdown",
    "total_should_be_100_percent",
    function (values) {
        const { createError } = this;

        if (!values?.doYouHaveAnExistingPortfolio) {
            return true;
        }

        const breakdownTotal =
            Number(values?.existingPublicEquity || 0) +
            Number(values?.existingPrivateEquity || 0) +
            Number(values?.existingRealEstate || 0) +
            Number(values?.existingPrivateCredit || 0) +
            Number(values?.existingFixedIncomeSukuk || 0) +
            Number(values?.existingMoneyMarketMurabaha || 0);

        if (breakdownTotal === 100 || breakdownTotal === 0) {
            return true;
        }

        return createError({
            path: "existingTotal",
            message: "total_should_be_100_percent",
        });
    }
).test(
    "target-portfolio-breakdown",
    "total_should_be_100_percent",
    function (values) {
        const { createError } = this;

        const targetBreakdownTotal =
            Number(values?.targetPublicEquity || 0) +
            Number(values?.targetPrivateEquity || 0) +
            Number(values?.targetRealEstate || 0) +
            Number(values?.targetPrivateCredit || 0) +
            Number(values?.targetFixedIncomeSukuk || 0) +
            Number(values?.targetMoneyMarketMurabaha || 0);

        if (targetBreakdownTotal === 100 || targetBreakdownTotal === 0) {
            return true;
        }

        return createError({
            path: "targetTotal",
            message: "total_should_be_100_percent",
        });
    }
);
